import { Injectable } from '@angular/core';
import { DiseasesModel, DiseaseModel } from '../../../models/master-data/diseases.model';
import { BaseService } from '../../../shared/services/base.service';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
@Injectable()
export class DiseasesService {
    constructor(public baseService: BaseService) {

    }

    getDiseaseList(param) {
        const url = MasterDataUrl.GET_ALL_DISEASE;
        return this.baseService.getData(url, param);
    }

    addNewDisease(param) {
      if(param) {
        param.isHaveVaccine = parseInt(param.isHaveVaccine, 0);
        }
        const url = MasterDataUrl.ADD_DISEASE;
        return this.baseService.postData(url, param);
    }

    updateDisease(id, param) {
        const url = MasterDataUrl.UPDATE_DISEASE + `${id}`;
        return this.baseService.update(url, param);
    }

    deleteDisease(id) {
        const url = MasterDataUrl.REMOVE_DISEASE.replace('{id}', id);
        return this.baseService.delete(url);
    }

    getDisease(id) {
        const url = MasterDataUrl.GET_DISEASE.replace('{id}',id);;
        return this.baseService.getData(url);
    }
    getLinkedData(): any[] {
      return [
          {
              id: 0,
              name: 'False'
          },
          {
              id: 1,
              name: 'True'
          }
      ];
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/diseases/diseases.service.ts